module.exports = __webpack_public_path__ + "static/media/logo-frankwatching-payoff.99100495.svg";


//////////////////
// WEBPACK FOOTER
// ./src/dist/images/logo-frankwatching-payoff.svg
// module id = 613
// module chunks = 0